/* ==========================================================================
   Bikeroom — "The Bikeroom Box" page kit
   Logica degli slot video + selettore tipo bici della sezione bkrm-box-steps.

   - Ogni .bkrm-vslot con data-bkrm-video è un placeholder: al click monta
     l'iframe (YouTube / Vimeo / URL embed) o un <video> nativo per i file
     caricati su Shopify (data-provider="hosted", sorgente in data-mp4),
     in autoplay. Nessun peso in più sulla pagina finché l'utente non clicca.
   - Sorgente vuota (data-yt / data-mp4 / data-src) => stato "coming soon".
   - Il selettore tipo bici legge le varianti da uno <script type="application/json">
     e aggiorna video + checklist + link senza ricaricare la pagina.
   ========================================================================== */
(function () {
  'use strict';

  var PLAY_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>';

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* URL YouTube/Vimeo -> URL embeddabile */
  function embedUrl(raw) {
    var u = String(raw || '').trim();
    if (!u) return '';
    var yt = u.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
    if (yt) return 'https://www.youtube-nocookie.com/embed/' + yt[1] + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    var vi = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vi) return 'https://player.vimeo.com/video/' + vi[1] + '?autoplay=1';
    return u;
  }

  function slotSource(slot) {
    var provider = slot.getAttribute('data-provider') || 'youtube';
    if (provider === 'hosted') {
      return (slot.getAttribute('data-mp4') || '').trim();
    }
    if (provider === 'youtube') {
      var id = (slot.getAttribute('data-yt') || '').trim();
      return id ? 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1' : '';
    }
    return embedUrl(slot.getAttribute('data-src'));
  }

  /* ricostruisce il placeholder dai data-attribute (serve anche dopo lo switch) */
  function renderPlaceholder(slot) {
    var soon = !slotSource(slot);
    var tag = slot.getAttribute('data-tag') || '';
    var title = slot.getAttribute('data-title') || '';
    var sub = soon ? (slot.getAttribute('data-soon') || 'Video coming soon') : (slot.getAttribute('data-sub') || '');
    var poster = slot.getAttribute('data-poster') || '';

    slot.classList.toggle('bkrm-vslot--soon', soon);
    slot.style.backgroundImage = poster ? 'url("' + poster + '")' : '';
    slot.removeAttribute('data-playing');
    slot.innerHTML =
      (tag ? '<span class="bkrm-vslot__tag">' + esc(tag) + '</span>' : '') +
      '<span class="bkrm-vslot__play">' + PLAY_SVG + '</span>' +
      ((title || sub)
        ? '<span class="bkrm-vslot__cap">' +
            (title ? '<b>' + esc(title) + '</b>' : '') +
            (sub ? '<small>' + esc(sub) + '</small>' : '') +
          '</span>'
        : '');
  }

  function play(slot) {
    if (slot.getAttribute('data-playing') === '1') return;
    var src = slotSource(slot);
    if (!src) return;
    slot.setAttribute('data-playing', '1');
    slot.style.backgroundImage = '';
    if ((slot.getAttribute('data-provider') || '') === 'hosted') {
      /* video Shopify: <video> nativo, niente iframe */
      var poster = slot.getAttribute('data-poster') || '';
      slot.innerHTML = '<video src="' + esc(src) + '"' + (poster ? ' poster="' + esc(poster) + '"' : '') +
        ' controls autoplay playsinline preload="metadata" title="' + esc(slot.getAttribute('data-title') || 'Video') + '"></video>';
      var v = slot.querySelector('video');
      if (v) v.play().catch(function () {});
    } else {
      slot.innerHTML = '<iframe src="' + esc(src) + '" title="' + esc(slot.getAttribute('data-title') || 'Video') +
        '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    }
  }

  function initSlots(scope) {
    scope.querySelectorAll('[data-bkrm-video]').forEach(function (slot) {
      if (slot.getAttribute('data-playing') === '1') return;
      renderPlaceholder(slot);
      if (slot.getAttribute('data-bound') === '1') return;
      slot.setAttribute('data-bound', '1');
      slot.setAttribute('role', 'button');
      slot.setAttribute('tabindex', '0');
      slot.addEventListener('click', function () { play(slot); });
      slot.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(slot); }
      });
    });
  }

  function initSelectors(scope) {
    scope.querySelectorAll('[data-bkrm-seg]').forEach(function (seg) {
      if (seg.getAttribute('data-bound') === '1') return;
      seg.setAttribute('data-bound', '1');

      var key = seg.getAttribute('data-bkrm-seg');
      var step = seg.closest('[data-bkrm-step]') || document;
      var json = step.querySelector('[data-bkrm-variants="' + key + '"]');
      var data = {};
      try { data = json ? JSON.parse(json.textContent) : {}; } catch (e) { data = {}; }

      var slot = step.querySelector('[data-bkrm-video]');
      var list = step.querySelector('[data-bkrm-list]');
      var link = step.querySelector('[data-bkrm-link]');

      function select(id) {
        var v = data[id];
        if (!v) return;

        seg.querySelectorAll('button').forEach(function (b) {
          b.setAttribute('aria-selected', b.getAttribute('data-variant') === id ? 'true' : 'false');
        });

        if (slot) {
          if (v.yt != null) slot.setAttribute('data-yt', v.yt || '');
          if (v.mp4 != null) slot.setAttribute('data-mp4', v.mp4 || '');
          if (v.src != null) slot.setAttribute('data-src', v.src || '');
          /* il video Shopify della variante ha priorità sull'ID YouTube */
          if (v.mp4 != null || v.yt != null || v.src != null) {
            var prov = v.mp4 ? 'hosted' : (v.yt ? 'youtube' : (v.src ? 'external' : 'youtube'));
            slot.setAttribute('data-provider', prov);
          }
          if (v.title) slot.setAttribute('data-title', v.title);
          if (v.sub != null) slot.setAttribute('data-sub', v.sub || '');
          if (v.poster != null) slot.setAttribute('data-poster', v.poster || '');
          renderPlaceholder(slot);
        }
        if (list && v.list) list.innerHTML = v.list;
        if (link) {
          if (v.link_url) link.setAttribute('href', v.link_url);
          if (v.link_label) {
            var lab = link.querySelector('[data-bkrm-link-label]');
            if (lab) lab.textContent = v.link_label;
          }
          link.style.display = v.link_url ? '' : 'none';
        }
      }

      seg.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () { select(b.getAttribute('data-variant')); });
      });

      var start = seg.querySelector('button[aria-selected="true"]') || seg.querySelector('button');
      if (start) select(start.getAttribute('data-variant'));
    });
  }

  function init(scope) {
    var root = scope || document;
    initSlots(root);
    initSelectors(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* theme editor: reinizializza quando la sezione viene ricaricata */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
